export const canadianData = {
	weekDays: [
		{
			value: 2,
			checked: false,
			title: "Monday",
			weekDay: 1,
		},
		{
			value: 4,
			checked: false,
			title: "Tuesday",
			weekDay: 2,
		},
		{
			value: 8,
			checked: false,
			title: "Wednesday",
			weekDay: 3,
		},
		{
			value: 16,
			checked: false,
			title: "Thursday",
			weekDay: 4,
		},
		{
			value: 32,
			checked: false,
			title: "Friday",
			weekDay: 5,
		},
		{
			value: 64,
			checked: false,
			title: "Saturday",
			weekDay: 6,
		},
		{
			value: 1,
			checked: false,
			title: "Sunday",
			weekDay: 0,
		},
	],
	selected: 0,
}
